<div class="dashboard-header">
  <div class="dashboard-title-wrapper">
    <h2>{{ "SIDENAV.ANALYTICS" | translate }}</h2>
    <p>{{ "DASHBOARD.GREETINGS.DESCRIPTION" | translate }}</p>
  </div>
  <div class="buttons-wrapper">
    <div class="filter-header">
      <div *ngIf="filters.length > 0">
        <lib-filter-checklist
          [filters]="filters"
          [useApply]="true"
          (resetFilterEmitter)="resetFilter()"
          (removeFilterEmitter)="removeFilter($event)"
          (applyFilterEmitter)="reloadDashboard()"
        ></lib-filter-checklist>
      </div>
      <button (click)="openFilterModal()">
        {{ "COMMON.ADD_FILTER.SINGLE" | translate }}
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
            fill="#0F0F0F"
          />
        </svg>
      </button>
    </div>

    <div class="filter-modal" *ngIf="showFilterModal">
      <div class="filter-tabs">
        <button
          class="tab active"
          [class.active]="activeTab === 'region'"
          (click)="setActiveTab('region')"
        >
          {{ "COMMON.BU.SINGLE" | translate }}
        </button>
        <button
          class="tab"
          [class.active]="activeTab === 'area'"
          (click)="setActiveTab('area')"
        >
          {{ "COMMON.UT.SINGLE" | translate }}
        </button>
        <button
          class="tab"
          [class.active]="activeTab === 'date'"
          (click)="activeTab = 'date'"
        >
          {{ "COMMON.DATE" | translate }}
        </button>
      </div>

      <div class="filter-search" *ngIf="activeTab != 'date'">
        <input
          type="text"
          placeholder="Search..."
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange()"
        />
        <button
          class="btn btn-primary"
          *ngIf="!this.selectedAll"
          (click)="this.selectAll()"
        >
          {{ "COMMON.SELECT_ALL" | translate }}
        </button>
        <button
          class="btn btn-primary"
          *ngIf="this.selectedAll"
          (click)="this.deselectAll()"
        >
          {{ "COMMON.DESELECT_ALL" | translate }}
        </button>
      </div>
      <div class="filter-list">
        <ng-container *ngIf="activeTab === 'region'">
          <label *ngFor="let region of filteredRegions">
            <input
              type="checkbox"
              [(ngModel)]="region.checked"
              (ngModelChange)="onRegionChange(region)"
            />
            {{ region.name }}
          </label>
        </ng-container>

        <ng-container *ngIf="activeTab === 'area'">
          <label *ngFor="let area of filteredAreas">
            <input
              type="checkbox"
              [(ngModel)]="area.checked"
              (ngModelChange)="onAreaChange(area)"
            />
            {{ area.name }}
          </label>
        </ng-container>

        <ng-container *ngIf="activeTab === 'date'">
          <div class="card">
            <div class="date-selection-left">
              <button
                class="filter-tab"
                [class.active]="activeDateFilter === 'custom'"
                (click)="setDateFilter('custom')"
              >
                {{ "COMMON.FILTER_BY_OPTIONS.CUSTOM" | translate }}
              </button>
              <button
                class="filter-tab"
                [class.active]="activeDateFilter === 'today'"
                (click)="setDateFilter('today')"
              >
                {{ "COMMON.FILTER_BY_OPTIONS.TODAY" | translate }}
              </button>
              <button
                class="filter-tab"
                [class.active]="activeDateFilter === 'yesterday'"
                (click)="setDateFilter('yesterday')"
              >
                {{ "COMMON.FILTER_BY_OPTIONS.YESTERDAY" | translate }}
              </button>
              <button
                class="filter-tab"
                [class.active]="activeDateFilter === 'this_week'"
                (click)="setDateFilter('this_week')"
              >
                {{ "COMMON.FILTER_BY_OPTIONS.THIS_WEEK" | translate }}
              </button>
              <button
                class="filter-tab"
                [class.active]="activeDateFilter === 'this_month'"
                (click)="setDateFilter('this_month')"
              >
                {{ "COMMON.FILTER_BY_OPTIONS.THIS_MONTH" | translate }}
              </button>
              <button
                class="filter-tab"
                [class.active]="activeDateFilter === 'this_year'"
                (click)="setDateFilter('this_year')"
              >
                {{ "COMMON.FILTER_BY_OPTIONS.THIS_YEAR" | translate }}
              </button>
            </div>

            <div class="divider"></div>

            <div class="date-selection-right">
              <div class="filter-item">
                <div class="date-filter-section">
                  <div
                    class="filter-row"
                    style="flex-direction: column; gap: 1rem"
                  >
                    <button
                      class="full-width"
                      [disabled]="activeDateFilter !== 'custom'"
                    >
                      <label>{{ "COMMON.DATE_FROM" | translate }}: </label>
                      <input
                        type="date"
                        [(ngModel)]="selectedDateFrom"
                        [disabled]="activeDateFilter !== 'custom'"
                      />
                    </button>

                    <button
                      class="full-width"
                      [disabled]="activeDateFilter !== 'custom'"
                    >
                      <label>{{ "COMMON.DATE_TO" | translate }}: </label>
                      <input
                        type="date"
                        [(ngModel)]="selectedDateTo"
                        [disabled]="activeDateFilter !== 'custom'"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="bottom-row">
        <button (click)="showFilterModal = !showFilterModal">
          {{ "COMMON.CANCEL" | translate }}
        </button>
        <button class="btn btn-primary" (click)="this.onAddFilter()">
          {{ "COMMON.ADD_FILTER.SINGLE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="dashboard-content">
  <div *ngIf="this.permissionsService.isDashboardAnalyticsOverviewAllowed">
    <div class="section">
      <div class="crud-section-title-wrapper">
        <h2>{{ "DASHBOARD.ANALYTICS_OVERVIEW.TITLE" | translate }}</h2>
        <p>{{ "DASHBOARD.ANALYTICS_OVERVIEW.DESCRIPTION" | translate }}</p>
      </div>
    </div>
    <div class="card-details-container">
      <lib-analytics-overview
        [customersData]="customersData"
        [buildingsData]="buildingsData"
        [poleData]="poleData"
        [distributionSubstationsData]="distributionSubstationsData"
        [tsData]="tsData"
        [substationData]="substationData"
        [f11Data]="f11Data"
        [f33Data]="f33Data"
        [feedersData]="feedersData"
        [cimFeedersData]="cimFeedersData"
        [mainFeederData]="mainFeederData"
        [primaryFeederData]="primaryFeederData"
        [secondaryFeederData]="secondaryFeederData"
        [hasCimDataIntegration]="hasCim"
        [substationTemplateStats]="substationTemplateStats"
        [equipmentData]="equipmentData"
        [sectionDefinitionData]="sectionDefinitionData"
        [areaIds]="areaIds"
      />
    </div>

    <div class="section">
      <div class="crud-section-title-wrapper">
        <h2>{{ "DASHBOARD.ASSET_BREAKDOWN.TITLE_V3" | translate }}</h2>
        <p>{{ "DASHBOARD.ASSET_BREAKDOWN.DESCRIPTION" | translate }}</p>
      </div>
    </div>
    <div class="card-details-container">
      <lib-total-asset-breakdown
        [customersData]="customersData"
        [buildingsData]="buildingsData"
        [poleData]="poleData"
        [distributionSubstationsData]="distributionSubstationsData"
        [tsData]="tsData"
        [substationData]="substationData"
        [sectionDefinitionData]="sectionDefinitionData"
        [deviceData]="deviceData"
        [f11Data]="f11Data"
        [f33Data]="f33Data"
        [feedersData]="feedersData"
        [cimFeedersData]="cimFeedersData"
        [mainFeederData]="mainFeederData"
        [primaryFeederData]="primaryFeederData"
        [secondaryFeederData]="secondaryFeederData"
        [equipmentData]="equipmentData"
        [substationTemplateStats]="substationTemplateStats"
        [hasCimDataIntegration]="hasCim"
        [areaIds]="areaIds"
        [dateFrom]="selectedDateFrom"
        [dateTo]="selectedDateTo"
      ></lib-total-asset-breakdown>
    </div>

    <div class="section">
      <div class="crud-section-title-wrapper">
        <div class="title-row">
          <h2>{{ "DASHBOARD.ASSET_BREAKDOWN.TITLE" | translate }}</h2>
          <div class="toggle-group">
            <button
              class="toggle-btn"
              [class.active]="isPrimaryGroupVisibleTaggedAssets"
              [disabled]="isPrimaryGroupVisibleTaggedAssets"
              (click)="toggleTaggedAssetCategory(true)"
              [attr.data-tooltip]="'Customers, Buildings, Poles, and Distribution Substations'"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.25 20.25V14.75H4.25C3.97386 14.75 3.75 14.9739 3.75 15.25V19.75C3.75 20.0261 3.97386 20.25 4.25 20.25H9.25ZM9.25 20.25H14.75M9.25 20.25V9.75C9.25 9.47386 9.47386 9.25 9.75 9.25H14.75V20.25M14.75 20.25H19.75C20.0261 20.25 20.25 20.0261 20.25 19.75V4.25C20.25 3.97386 20.0261 3.75 19.75 3.75H15.25C14.9739 3.75 14.75 3.97386 14.75 4.25V20.25Z" 
              [attr.stroke]="isPrimaryGroupVisibleTaggedAssets ? '#ffffff' : '#ccc'" 
                              stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
              </svg>
            </button>

            <button
              class="toggle-btn"
              [class.active]="!isPrimaryGroupVisibleTaggedAssets"
              [disabled]="!isPrimaryGroupVisibleTaggedAssets"
              (click)="toggleTaggedAssetCategory(false)"
              [attr.data-tooltip]="'Injection Substations, Transmission Stations, Feeders, and Devices'"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.25 20.25V13.75H4.25C3.97386 13.75 3.75 13.9739 3.75 14.25V19.75C3.75 20.0261 3.97386 20.25 4.25 20.25H9.25ZM9.25 20.25H14.75M9.25 20.25V4.25C9.25 3.97386 9.47386 3.75 9.75 3.75H14.25C14.5261 3.75 14.75 3.97386 14.75 4.25V20.25M14.75 20.25H19.75C20.0261 20.25 20.25 20.0261 20.25 19.75V9.25C20.25 8.97386 20.0261 8.75 19.75 8.75H14.75V20.25Z"
              [attr.stroke]="!isPrimaryGroupVisibleTaggedAssets ? '#ffffff' : '#ccc'" 
                    stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>

        </div>
        <p>{{ "DASHBOARD.ASSET_BREAKDOWN.DESCRIPTION_V3" | translate }}</p>
      </div>
    </div>

    <div class="card-details-container">
      <lib-tagged-asset-breakdown
        [lineGraphData]="graphData"
        (getData)="getGraphData($event)"
      >
      </lib-tagged-asset-breakdown>
    </div>
  </div>

  <div *ngIf="permissionsService.isDashboardOperationsAnalyticsAllowed">
    <div class="section">
      <div class="crud-section-title-wrapper">
        <h2>{{ "DASHBOARD.OPERATIONS_ANALYTICS.TITLE" | translate }}</h2>
        <p>{{ "DASHBOARD.OPERATIONS_ANALYTICS.DESCRIPTION" | translate }}</p>
      </div>
    </div>
    <div class="card-details-container">
      <lib-operations-analytics
        [lineGraphData]="lineGraphData"
        [customerCount]="customersData.totalCount"
        [counts]="assetsCounts"
        (getData)="getOperationsAnalytics($event)"
      >
      </lib-operations-analytics>
    </div>
  </div>
  
  <div *ngIf="permissionsService.isDashboardMeterValidationAllowed">
    <div class="section">
      <div class="crud-section-title-wrapper">
        <h2>{{ "COMMON.METER_VALIDATION" | translate }}</h2>
        <p>{{ "DASHBOARD.ANALYTICS_OVERVIEW.DESCRIPTION" | translate }}</p>
      </div>
    </div>
    <div class="card-details-container">
      <lib-dashboard-meter-validation></lib-dashboard-meter-validation>
    </div>
  </div>
</div>
